import {ChangeDetectionStrategy, Component, input, ViewEncapsulation} from '@angular/core';
import {TrackEventDirective} from "../../../../app/presentation/directives/track-event.directive";

@Component({
  selector: 'app-donate-car-button',
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TrackEventDirective
  ],
  template: `
    <a [trackEvent]="eventParams()" href="/donate-car"
       class="w-full h-[70px] px-[18px] secondary-button border-2 border-[#1f2024] justify-center items-center gap-[7px] inline-flex">
      <div class="text-center text-2xl font-medium leading-loose tracking-[2.88px]">
        DONATE CAR
      </div>
    </a>
  `
})
export class DonateCarButtonComponent {

  public readonly eventParams = input.required<{
    trackEvent: string;
    section: string;
  }>();

}
